"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsomorphicLayoutEffect = void 0;
var _react = require("react");
var _server = require("b2b-components/utils/server");
const useIsomorphicLayoutEffect = exports.useIsomorphicLayoutEffect = !_server.isServer ? _react.useLayoutEffect : _react.useEffect;
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map